import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Tabs,
  Tab,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import UploadIcon from "@mui/icons-material/Upload";
import useApi from "../../../api/useApi";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router";
import ScrollStory from "../../sections/ScrollStory";
import { useAuth } from "../../../hooks/useAuth";
import { OrgMetaGet } from "../../../api/orgService";
import SkeletonCard from "../../sections/SkeletonCard";

export default function MetadataAdmin({ onAddcategory, updateLoading }) {
  const CATEGORY_FORM_STORAGE_KEY = "ourValuesFormState";
  const { request: getAllMetaData, data:orgMetaData, error:orgMetaDataError,isLoading:metaDataLoading} = useApi(OrgMetaGet);
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  const [orgValues, setOrgValues] = useState([]);
  const [uploadingImage, setUploadingImage] = useState(false);
  const fileInputRef = useRef(null);

  const [content, setContent] = useState({
    title: "",
    text: "",
    img: "",
  });

  const [currentIndex, setCurrentIndex] = useState(null)
  const [tabPreviewCreate, setTabPreviewCreate] = useState(0);
  const [tabIndex, setTabIndex] = useState(0); // Link / Upload

  const { request: createCategory, data: createCategoryData, error: createCategoryError } =
    useApi(onAddcategory);

    useEffect(() => {
        // console.log(partnerGetAllData)
        getAllMetaData(1)
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        // console.log(partnerGetAllData)
        if(orgMetaData?.data){
            const values = orgMetaData.data.org_metadata?.values || [];
        //  setOrgValues(orgMetaData?.data?.org_metadata?.values || []);
        setOrgValues([...values]);
        }
        // eslint-disable-next-line
    }, [orgMetaData]);

  // Load previous metadata values
//   useEffect(() => {
//     if (previousValues) {
//       setOrgValues(previousValues?.org_metadata?.values || []);
//     }
//   }, [previousValues, location]);

  // Keep form in localStorage
  useEffect(() => {
    window.localStorage.setItem(CATEGORY_FORM_STORAGE_KEY, JSON.stringify(content));
  }, [content]);

   
    useEffect(() => {
        const singleValue = location?.state?.single_value;
      
        if (singleValue) {
          console.log("Loaded single value: ", singleValue);
      
          // force new object reference
          setContent({ ...singleValue?.val });
          setCurrentIndex(singleValue?.index)
        }
      }, [location?.state?.single_value]);


  // Add new value to the list when content is complete
  // useEffect(() => {
  //   if (content && currentIndex) {

  //     let updated = orgValues?.map((item, i) => i === currentIndex ? content : item)
  //     console.log("check: ",updated)
  //       setOrgValues([... updated]);
  //   }
  // }, [content,currentIndex]);

  // Success create handler
  useEffect(() => {
    if (createCategoryData?.status === 200) {
      toast.success("Value added successfully!", { position: "top-center" });

      window.localStorage.removeItem(CATEGORY_FORM_STORAGE_KEY);
      setContent({ title: "", text: "", img: "" });

      navigate("/staff/organisation/", { state: { redirect: "list-org" } });
    }
  }, [createCategoryData]);

  // Error create handler
  useEffect(() => {
    if (createCategoryError) {
      toast.error(JSON.stringify(createCategoryError?.response?.data, null, 2), {
        position: "top-center",
      });
    }
  }, [createCategoryError]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setContent((prev) => ({ ...prev, [name]: value }));
  };

  const handleDelete = () => {
    let remaining = orgValues.filter((_, i) => i !== currentIndex);
  
    const dataToSend = {
      org_metadata: { values: remaining },
      id: user?.user?.org,
    };
  
    createCategory(user?.user?.org, dataToSend);
  };

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const previewUrl = URL.createObjectURL(file);
    setContent((prev) => ({ ...prev, value: previewUrl }));

    const formData = new FormData();
    formData.append("image", file);

    setUploadingImage(true);
    try {
      const res = await fetch("https://fountainafrica.org/cms/ftp-files/", {
        method: "POST",
        body: formData,
      });

      if (res.status === 201) {
        const result = await res.json();
        setContent((prev) => ({ ...prev, img: result.path }));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setUploadingImage(false);
    }
  };

  // const handleSubmit = () => {
  //   if (!content.title) return alert("Please enter a title.");
  //   if (!content.text) return alert("Please enter the text description.");

  //   const dataToSend = {
  //     org_metadata: { values: orgValues },
  //     id: user?.user?.org,
  //   };

  //   createCategory(user?.user?.org, dataToSend);
  // };
  const handleSubmit = () => {
    if (!content.title) return alert("Please enter a title.");
    if (!content.text) return alert("Please enter the text description.");
  
    let updatedValues = [...orgValues];
    updatedValues[currentIndex] = content;
  
    const dataToSend = {
      org_metadata: { values: updatedValues },
      id: user?.user?.org,
    };
  
    createCategory(user?.user?.org, dataToSend);
  };
  
  const handleCancel = (e)=>{
    navigate(-1)
  }

  if(metaDataLoading){
    return <SkeletonCard />
  }

  return (
    <Box sx={{ padding: 3, maxWidth: 700, margin: "0 auto" }}>
      <Typography variant="h5" fontWeight="bold" sx={{ mb: 3 }}>
        Edit Values Statement
      </Typography>

      <Typography sx={{ mb: 4 }}>
        Edit a value statement that represents what your organization stands for.
      </Typography>

      {/* Create / Preview Tabs */}
      <Tabs
        value={tabPreviewCreate}
        onChange={(e, v) => setTabPreviewCreate(v)}
        centered
        sx={{ mb: 3 }}
      >
        <Tab label="New Value" />
        <Tab label="Preview" />
      </Tabs>

      {tabPreviewCreate === 0 ? (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
          {/* TITLE */}
          <TextField
            name="title"
            label="Title"
            value={content.title}
            onChange={handleChange}
            fullWidth
          />

          {/* TEXT DESCRIPTION */}
          <TextField
            name="text"
            label="Description"
            value={content?.text}
            placeholder="Explain the value briefly..."
            onChange={handleChange}
            fullWidth
            multiline
            minRows={4}
          />

          {/* Image Tabs */}
          <Tabs
            value={tabIndex}
            onChange={(e, v) => setTabIndex(v)}
            centered
            sx={{ mb: 2 }}
          >
            <Tab label="Image Link" />
            <Tab label="Upload Image" />
          </Tabs>

          {/* Image Link */}
          {tabIndex === 0 && (
            <TextField
              name="img"
              label="Image Link"
              value={content.img}
              onChange={handleChange}
              fullWidth
            />
          )}

          {/* Image Upload */}
          {tabIndex === 1 && (
            <Box
              sx={{
                border: "2px dashed #ccc",
                p: 3,
                borderRadius: 2,
                textAlign: "center",
              }}
            >
              {content.img && (
                <img
                  src={content?.img}
                  alt="preview"
                  style={{
                    width: "100%",
                    borderRadius: 8,
                    marginBottom: 10,
                  }}
                />
              )}

              <Button variant="outlined" onClick={() => fileInputRef.current.click()}>
                {uploadingImage ? "Uploading..." : content.img ? "Change File" : "Upload Image"}
              </Button>

              <input
                type="file"
                ref={fileInputRef}
                accept="image/*"
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
            </Box>
          )}

          {/* SUBMIT */}
          <Button variant="contained"  color="success" onClick={handleSubmit} startIcon={<AddIcon />}>
            Save Value Statement
          </Button>
          
          <Button variant="contained"  onClick={handleCancel} startIcon={<AddIcon />}>
            Cancel
          </Button>

          <Button variant="contained" color="error" onClick={handleDelete} startIcon={<AddIcon />}>
            Delete Value Statement
          </Button>
        </Box>
      ) : (
        <ScrollStory ourValues={orgValues} />
      )}
    </Box>
  );
}
